import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-cliente-detalhar',
  templateUrl: './cliente-detalhar.component.html',
  styleUrls: ['./cliente-detalhar.component.scss']
})
export class ClienteDetalharComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  loadingCliente: boolean = true;
  cliente?: Cliente;
  listaContatos: ContatoCliente[] = [];
  @ViewChild('f') form?: NgForm;

  constructor(private activatedRouter: ActivatedRoute,
    private clienteService: ClienteService,
    private contatoClienteService: ContatoClienteService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.permissaoDetalhar = this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_CLIENTE');
    this.carregarIdCliente();
    if (this.permissaoDetalhar) {
      this.carregarClientePorId();
    }
  }

  carregarClientePorId() {
    this.clienteService.buscarPorId(this.id).subscribe({
      next: (data: Cliente) => {
        this.cliente = data;
        this.carregarContatosCliente();
      },
      error: (error: any) => {
        this.loadingCliente = false;
        this.exibirMensagemErro(error);
      }
    }

    );
  }

  
  carregarContatosCliente() {
    this.contatoClienteService.listarPorClienteId(this.cliente?.id).subscribe({
      next: (data: ContatoCliente[]) => {
        this.listaContatos = data;
        this.loadingCliente = false;
      },
      error: (error: any) => {
        this.loadingCliente = false;
        this.exibirMensagemErro(error);
      }
    })
  }

  carregarIdCliente() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

}
